import React from 'react'
import NavBar from '../Components/Main/NavBar'
import Footer from '../Components/Main/Footer'
import '../css/Main/Contact.css'

const ThankYou = () => {
  return (
    <div>
        <NavBar/>
        <div className='thankyou'>
            Köszönjük szépen, üzenetét megkaptuk!
        </div>
        <Footer/>
    </div>
  )
}

export default ThankYou